import React from 'react';

// DEPRECATED: remove this component and use  src/components/generic/Spinner.component.jsx
const Spinner = ({ color, message }) => (
  <div data-bem="Spinner--common" className="loader-bgr">
    <p className="loading-text">{message}</p>
    <div className="loader fixed">
      <svg className="circular">
        <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="3" strokeMiterlimit="10" stroke={color} />
      </svg>
    </div>
  </div>
);

export default Spinner;
